import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { filter, Subject, takeUntil } from "rxjs";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { CartService } from "src/app/core/services/cart-service";
import { PedidoService } from "src/app/core/services/pedido-service";
import { ProductService } from "src/app/core/services/product-service";
import { SecurityService } from "src/app/core/services/security-service";
import { getOrderItemFromProduct } from "../shared/function";
import { ProductImageComponent } from "../product-image/product-image.component";
import { CatalogItemComponent } from "../../components/catalog-item/catalog-item.component";
import { ToastrService } from "ngx-toastr";
import { ConfiguracoesMisc } from "src/app/core/entities/configuracoesMisc";
import { ActivatedRoute, Router } from "@angular/router";
import { CorteService } from "src/app/modules/product/services/corte.service";
declare var $: any;
@Component({
  selector: "app-catalog-item-line",
  templateUrl: "./catalog-item-line.component.html",
  styleUrls: ["./catalog-item-line.component.css"],
})
export class CatalogItemLineComponent implements OnInit, OnChanges, OnDestroy {
  public site: ConfiguracoesSite;
  MISC: ConfiguracoesMisc;
  productList: QueryList<CatalogItemComponent>;
  @Input()
  public products: any[];

  @Input()
  public produtoColXL;

  @Input()
  public produtoHeight;

  @Input()
  public produtoDescrHeight;

  @Input()
  public produtoDescrFontSize;

  @Input()
  public produtoIndispFontSize;

  @Input()
  public produtoDescrLen;

  @Output()
  public redirectTo = new EventEmitter<number>();

  @ViewChild("productImage", { read: ProductImageComponent, static: true })
  public productImage!: ProductImageComponent;

  public showStock: boolean;
  public userLogged: boolean = false;
  public validaEstoque: boolean;
  public quantity: number = 0;
  public pedido: any;
  public API_IMAGENS: String;
  public API_IMAGENS_PRODUTOS: String;
  public SITE: ConfiguracoesSite;
  public mostraPreco = false;
  public stock: string;
  public showProduct = false;
  public selectedProduct = null;
  public config: ConfiguracoesMisc;

  private destroy$ = new Subject<void>();

  constructor(
    public toastService: ToastrService,
    public productService: ProductService,
    public securityService: SecurityService,
    public pedidoService: PedidoService,
    private router: Router,
    public cartService: CartService,
    private corteService: CorteService
  ) {
    this.site = Configuracoes.SITE;
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    this.SITE = Configuracoes.SITE;
    this.config = Configuracoes.MISC;

    this.pedido = this.pedidoService.pedido;
    if (!this.securityService.hasToken() && !this.SITE.mostraPrecoLoginAtivo)
      this.mostraPreco = true;
    if (
      this.securityService.hasToken() &&
      (!this.SITE.mostraPrecoPedidoSelecionado || this.pedido)
    ) {
      this.mostraPreco = true;
    }

    if (this.securityService.hasToken()) {
      this.userLogged = true;
    }
  }

  ngOnInit() {
    if (this.pedido) {
      this.validaEstoque = this.pedido.tipo.validaEstoque;
    }
    // } else {
    this.showStock = this.SITE.mostraEstoqueDigitacao;
    // }

    this.aplicarQuantidadesCarrinhoNaGrade();
    this.pedidoService.pedido$
      .pipe(
        takeUntil(this.destroy$),
        filter((p) => p != null)
      )
      .subscribe(() => this.aplicarQuantidadesCarrinhoNaGrade());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["products"] && this.products?.length) {
      this.aplicarQuantidadesCarrinhoNaGrade();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Atualiza `quantidadeCarrinho` em cada linha a partir do pedido em memória (sem novo request de catálogo). */
  private aplicarQuantidadesCarrinhoNaGrade(): void {
    if (!this.products?.length) {
      return;
    }
    for (const p of this.products) {
      if (p?.id != null) {
        p.quantidadeCarrinho = this.productService.getQuantityByProductId(p.id);
        // Para corte:
        // - badge `product-quantity` usa `quantidadeCarrinho` como peso total
        // - input readonly usa `product.quantidade` como total ajustado (com sobra)
        if (this.corteService.deveUsarPaginaCorte(p, false)) {
          const peso = this.productService.getPesoTotalCorteByProductId(p.id);
          if (peso > 0) {
            p.quantidadeCarrinho = peso;
          }
          const totalFinal = this.productService.getQuantityByProductId(p.id);
          if (totalFinal > 0) {
            p.quantidade = totalFinal;
          }
        }
      }
    }
  }

  callPhotos(idProduto, codCor) {
    this.productService.getPhotos(
      idProduto,
      function (resp) {
        let temVariacao = false;
        let _htmlImagens = "";
        for (let i = 0; i < resp.length; i++) {
          let img = resp[i];
          _htmlImagens +=
            '<a href="' +
            Configuracoes.API_IMAGENS_PRODUTOS +
            img.nome +
            '" data-gallery="gallery-catalogo"></a>';
        }
        $("#htmlLightBox").html(_htmlImagens);
        $("#htmlLightBox a:first").ekkoLightbox();
      }.bind(this)
    );

    this.showProduct = false;
    if (Configuracoes.exibeModalProdutoCatalogo) {
      setTimeout(() => {
        this.selectedProduct = idProduto;
        this.showProduct = true;
        $("#productDetails").modal("show");
      });
    } else {
      this.router.navigate(["/produto", idProduto]);
    }
  }

  public addCart(quantity: number, product) {
    this.updateQuantity2(quantity, product);
    if (product.sku) {
      const tax = product.imposto;
      const price = product.precopromocional
        ? product.precopromocional
        : product.preco;

      let taxValue = null;
      let taxCalc = {};

      if (tax) {
        taxCalc = this.productService.calculaImposto(
          price,
          tax.ipi,
          tax.alicms,
          tax.substicms,
          tax.alicmsorigem,
          tax.fcpSt
        );
        taxValue = this.productService.calculaValorImposto(
          price,
          tax.ipi,
          tax.alicms,
          tax.substicms,
          tax.alicmsorigem,
          tax.fcpSt
        );
      }
      const item = getOrderItemFromProduct(
        product,
        taxCalc,
        tax,
        taxValue,
        this.pedidoService.pedido.clientes[0].cliente.id,
        quantity,
        quantity * this.getPrice(product)
      );
      this.pedidoService.setCartItemsSku(
        [item],
        (res) => this.doOnSuccess(res, [item]),
        (res) => this.doOnError(res)
      );
    }
  }

  public doOnSuccess(res, items) {
    // let response = {...res, itens: res.itens.map((r: any)=> ({...r, produtoreferencia: r.produtoReferencia}))}
    this.cartService.addItems(items);
    this.pedidoService.select(res);
    this.aplicarQuantidadesCarrinhoNaGrade();
  }

  public doOnError(res) {
    // let response = {...res, itens: res.itens.map((r: any)=> ({...r, produtoreferencia: r.produtoReferencia}))}
    if (res.status === 400) {
      this.toastService.error(res.error.detail, $localize`Produto`, {
        positionClass: "toast-bottom-left",
      });
      // window.location.reload();
    }
  }

  public getPrice(product) {
    let taxValue = 0;
    const tax = product.imposto;

    if (tax) {
      const price = product.precopromocional
        ? product.precopromocional
        : product.preco;
      taxValue = this.productService.calculaValorImposto(
        price,
        tax.ipi,
        tax.alicms,
        tax.substicms,
        tax.alicmsorigem,
        tax.fcpSt
      );
    }

    return product.preco + taxValue;
  }

  updateQuantity(productId: number) {
    let quantity = this.productService.getQuantityByProductId(productId);
    let found: CatalogItemComponent = this.productList.filter(
      (comp) => comp.product.id == productId
    )[0];
    found.updateQuantity(quantity);
  }

  public updateQuantity2(quantity, product) {
    product.quantidade = quantity;
    // this.productImage.updateQuantity(quantity);
    this.ngOnInit();
  }

  redirectTo2(id: number) {
    const p = this.products?.find((x: any) => x.id === id);
    if (this.corteService.deveUsarPaginaCorte(p, false)) {
      this.productService.stashCurrentCatalogUiForReturn();
      this.router.navigate(["/produto-corte", id], {
        queryParams: { corte: "1" },
      });
      return;
    }
    this.showProduct = false;
    if (Configuracoes.exibeModalProdutoCatalogo) {
      setTimeout(() => {
        this.selectedProduct = id;
        this.showProduct = true;
        $("#productDetails").modal("show");
      });
    } else {
      this.router.navigate(["/produto", id]);
    }
  }
}
